import pluralize from 'pluralize';
import { memo } from 'react';

import { usePrivateWorkspaceAgentAssetListContext } from '~/components/v2/components/workspace/workspace-agent-asset-list/PrivateWorkspaceAgentAssetListProvider';

export const PrivateWorkspaceAgentAssetListCount = memo(() => {
  const { failedCount, hasMore, isError, isLoading, isWrongType, totalCount, unavailableCount } =
    usePrivateWorkspaceAgentAssetListContext();

  if (isLoading || isError || isWrongType) {
    return null;
  }

  // More rows are still on the server, so the count so far is a floor.
  const countLabel = `${totalCount.toLocaleString()}${hasMore ? '+' : ''} ${pluralize('item', totalCount)}`;

  const unavailableLabel = unavailableCount > 0 ? ` · ${unavailableCount.toLocaleString()} unavailable` : '';
  // A failed lookup is not deleted content, so it gets its own label instead of "unavailable".
  const failedLabel = failedCount > 0 ? ` · ${failedCount.toLocaleString()} couldn't load` : '';

  return (
    <span
      className="whitespace-nowrap ads:text-metadata text-12 text-gray-10"
      data-testid="WORKSPACE_AGENT_ASSET_LIST_COUNT"
    >
      {countLabel}
      {unavailableLabel}
      {failedLabel}
    </span>
  );
});

PrivateWorkspaceAgentAssetListCount.displayName = 'PrivateWorkspaceAgentAssetListCount';
